import { BsLink45Deg } from 'react-icons/bs';

import BayTooltip from '../../BayTooltip';
import { StyledNavButton } from '../styles/navStyles';

interface QuickLinksButtonProps {
	toggleFunc: () => void;
}

const QuickLinksButton = ({ toggleFunc }: QuickLinksButtonProps) => {
	return (
		<BayTooltip overlay={<span>Quick Links</span>} placement="bottom">
			<StyledNavButton className="desktop-menu-icons" onClick={toggleFunc}>
				<BsLink45Deg size={16} />
			</StyledNavButton>
		</BayTooltip>
	);
};
export default QuickLinksButton;
